"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLinks = void 0;
var react_1 = __importDefault(require("react"));
var slate_react_1 = require("slate-react");
var Link_1 = require("@styled-icons/material/Link");
var slate_1 = require("slate");
var isUrl = function isUrl(url) {
  var re = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
  return re.test(url);
};
var isActive = function isActive(editor) {
  var it = slate_1.Editor.nodes(editor, {
    match: function match(n) {
      return !slate_1.Editor.isEditor(n) && slate_1.Element.isElement(n) && n.type === 'a';
    }
  });
  return !!it.next().value;
};
var withLinks = function withLinks(editor) {
  var insertData = editor.insertData,
    insertText = editor.insertText,
    isInline = editor.isInline;
  editor.isInline = function (element) {
    return element.type === 'a' ? true : isInline(element);
  };
  editor.insertText = function (text) {
    if (text && isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertText(text);
    }
  };
  editor.insertData = function (data) {
    var text = data.getData('text/plain');
    if (text && isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertData(data);
    }
  };
  return editor;
};
exports.withLinks = withLinks;
var insertLink = function insertLink(editor, url) {
  if (editor.selection) {
    wrapLink(editor, url);
  }
};
var wrapLink = function wrapLink(editor, url) {
  var link = {
    type: 'a',
    href: url,
    children: []
  };
  slate_1.Transforms.wrapNodes(editor, link, {
    split: true
  });
  slate_1.Transforms.collapse(editor, {
    edge: 'end'
  });
};
function HyperLinkButton() {
  var editor = slate_react_1.useSlate();
  var active = isActive(editor);
  return react_1.default.createElement("div", {
    title: "\u8D85\u9023\u7D50",
    style: {
      margin: 3,
      width: 30,
      height: 30,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: active ? 'bold' : 'normal',
      backgroundColor: active ? '#eee' : 'white'
    },
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      if (active) {
        if (window.confirm('確定要移除連結')) {
          slate_1.Transforms.unwrapNodes(editor, {
            match: function match(n) {
              return !slate_1.Editor.isEditor(n) && slate_1.Element.isElement(n) && n.type === 'a';
            }
          });
        }
      } else {
        var isCollapsed = editor.selection && slate_1.Range.isCollapsed(editor.selection);
        if (isCollapsed) {
          return alert('請選擇一段文字');
        }
        var url = window.prompt('Enter the URL of the link:');
        if (!url) {
          return;
        }
        insertLink(editor, url);
      }
    }
  }, react_1.default.createElement(Link_1.Link, {
    size: 16,
    color: "black"
  }));
}
exports.default = HyperLinkButton;